import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { fetchNewsletterLeads } from "../../actions/commonController"
import { Button } from "react-bootstrap"

const NewsletterLeads = () => {
    const [data, setData] = useState([])
    // eslint-disable-next-line no-unused-vars
    const [page, setPage] = useState(1)
    // eslint-disable-next-line no-unused-vars
    const [quantity, setQuantity] = useState(10)

    const loadData = async() => {
        try {
            setData([])
            let { status, data } = await fetchNewsletterLeads(page, quantity)
            if(status === "success") setData(data)
        } catch (err) {
            toast.error(err.message)
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { loadData() }, [page, quantity])

    return (
        <div className="row">
            <div className={`col-12 pt-`}>
                <div className="card">
                    <div className="card-header">
                        <h4 className="header-title m-0">
                            Newsletter Leads -  List
                            <Button style={{ marginLeft: "10px" }} onClick={loadData}>Click here to refresh</Button>
                        </h4>
                    </div>
                    <div className="card-body pt-0">
                        <div className="row">
                            <table className="table table-striped dt-responsive nowrap w-100">
                                <thead>
                                    <tr>
                                        <th>S. No</th>
                                        <th>Email</th>
                                        <th>Created At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data && data.length > 0 && data.map((item, index) => (
                                            <tr key={item.id || index}>
                                                <td>{index+1}</td>
                                                <td>{item.email}</td>
                                                <td>{(new Date(item.createdAt)).toLocaleDateString('en-GB') + ' ' + (new Date(item.createdAt)).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewsletterLeads